module.exports = __webpack_public_path__ + "img/1716366218162-WhatsApp Image 2024-05-22 at 13.50.21.jpeg.25ac8a1b.webp";